import * as t from 'io-ts';
import {
  Area,
  AreasSuggestionResponse,
  ExploreArea,
  ExploreStation,
  Line,
  MerchantCategory,
  MultiExploreAreaResponse,
  Station,
} from '../api/backend/client';

export const VArea: t.Type<Area> = t.recursion('VArea', () =>
  t.type({
    id: t.number,
    localName: t.string,
    normalizedName: t.string,
    parentAreaId: t.union([t.number, t.nullType]),
    parentArea: t.union([VArea, t.nullType]),
  }),
);

const VMerchantCategory: t.Type<MerchantCategory> = t.type({
  id: t.number,
  nameJA: t.string,
  nameEN: t.string,
  nameKO: t.string,
  displayOrder: t.number,
  imageUrl: t.string,
});

const VExploreArea: t.Type<ExploreArea> = t.type({
  area: VArea,
  merchantCategory: VMerchantCategory,
  merchantCount: t.number,
});

export const VMultiExploreAreaResponse: t.Type<MultiExploreAreaResponse> = t.type(
  {
    exploreAreas: t.array(VExploreArea),
  },
);

const VLine: t.Type<Line> = t.type({
  id: t.number,
  originalLineId: t.number,
  name: t.string,
});

const VStation: t.Type<Station> = t.type({
  id: t.number,
  originalStationId: t.number,
  name: t.string,
  lineId: t.number,
  line: VLine,
  prefectureAreaId: t.number,
  prefectureArea: VArea,
  areaId: t.union([t.number, t.nullType]),
  area: t.union([VArea, t.nullType]),
});

const VExploreStation: t.Type<ExploreStation> = t.type({
  merchantCategory: VMerchantCategory,
  station: VStation,
  merchantCount: t.number,
});

export const VAreasSuggestionResponse: t.Type<AreasSuggestionResponse> = t.type(
  {
    areas: t.array(VExploreArea),
    stations: t.array(VExploreStation),
  },
);
